import Dashboard from "views/Dashboard.js";
import Notifications from "views/Notifications.js";
import Icons from "views/Icons.js";
import Typography from "views/Typography.js";
import TableList from "views/TableList.js";
import Maps from "views/Maps.js";
import Upgrade from "views/Upgrade.js";
import UserPage from "views/UserPage.js";
//import Principal from "views/Principal.js";
import Tendencias from "views/Tendencias.js";
import Historico from "views/Historico.js";
import Principal from './components/Prueba';
import DatosGenerales from './components/DatosGenerales';
import DatosGenerales_posext from './components/DatosGenerales_posext';
import Salud from './components/Salud';
import Direcciones from './components/Direcciones';
import Direcciones_posext from './components/Direcciones_posext';
import Telefonos from './components/Telefonos';
import ContactosEmergencia from './components/ContactosEmergencia';
import ContactosEmergencia_posext from './components/ContactosEmergencia_posext';
import InformacionFamiliar from './components/InformacionFamiliar';
import InformacionAcademica from './components/InformacionAcademica';
import InformacionAcademica_posext from './components/InformacionAcademica_posext';
import Experiencia from './components/Experiencia';
import Experiencia_posext from './components/Experiencia_posext';
import Capacitaciones from './components/Capacitaciones';
import MencionesHonor from './components/MencionesHonor';
import Idiomas from './components/Idiomas';
import Patentes from './components/Patentes';
import Evaluaciones from './components/Evaluaciones';
import CertificacionProfesional from './components/CertificacionProfesional';
import ExperienciaProyectos from './components/ExperienciaProyectos';
import PublicacionesRealizadas from "./components/PublicacionesRealizadas";
import DireccionTesis from "./components/DireccionTesis";
import MiembroOrganizacion from "./components/MiembroOrganizacion";
import ActividadesAcademicas from "./components/ActividadesAcademicas";
import DesarrolloProfesional from "./components/DesarrolloProfesional";
import Convenios from "components/Datos Personales/Convenios/Convenios.tsx";
import ContratosBecas from "components/Datos Personales/Contrato Becas/ContratosBecas";
import SustitutoInformacionFamiliar from "components/Datos Personales/SustitutoInformacionFamiliar/SustitutoInformacionFamiliar";
import OtrosProductos from "./components/OtrosProductos";

var dashRoutes = [
    {
        path: "/datos-generales",
        name: "DATOS GENERALES",
        icon: "datos_generales",
        component: DatosGenerales,
        layout: "/admin",
        color: "#EFEFEF",
        rol: ["DOCENTEGRADO,", "ADMINISTRATIVO,", "DOCENTEPOSTGRADO,", "USUARIO,"]
    },
    {
        path: "/datos-generales-pos",
        name: "DATOS GENERALES",
        icon: "datos_generales",
        component: DatosGenerales_posext,
        layout: "/admin",
        color: "#EFEFEF",
        rol: ["DOCENTEPOSTGRADO_EXT,"]
    },
    {
        path: "/salud",
        name: "SALUD",
        icon: "salud",
        component: Salud,
        layout: "/admin",
        color: "#EFEFEF",
        rol: ["DOCENTEGRADO,", "ADMINISTRATIVO,", "USUARIO,"]
    },
    {
        path: "/direcciones",
        name: "DIRECCIONES",
        icon: "direcciones",
        component: Direcciones,
        layout: "/admin",
        color: "#EFEFEF",
        rol: ["DOCENTEGRADO,", "ADMINISTRATIVO,", "DOCENTEPOSTGRADO,", "USUARIO,"]
    },
    {
        path: "/direcciones-pos",
        name: "DIRECCIONES",
        icon: "direcciones",
        component: Direcciones_posext,
        layout: "/admin",
        color: "#EFEFEF",
        rol: ["DOCENTEPOSTGRADO_EXT,"]
    },
    {
        path: "/telefonos",
        name: "TELÉFONOS",
        icon: "telefonos",
        component: Telefonos,
        layout: "/admin",
        color: "#EFEFEF",
    },
    {
        path: "/contactos-de-emergencia",
        name: "CONTACTOS DE EMERGENCIA",
        icon: "contactos_emergencia",
        component: ContactosEmergencia,
        layout: "/admin",
        color: "#EFEFEF",
        rol: ["DOCENTEGRADO,", "ADMINISTRATIVO,", "DOCENTEPOSTGRADO,", "USUARIO,"]
    },
    {
        path: "/contactos-de-emergencia-pos",
        name: "CONTACTOS DE EMERGENCIA",
        icon: "contactos_emergencia",
        component: ContactosEmergencia_posext,
        layout: "/admin",
        color: "#EFEFEF",
        rol: ["DOCENTEPOSTGRADO_EXT,"]
    },
    {
        path: "/informacion-familiar",
        name: "INFORMACIÓN FAMILIAR",
        icon: "informacion_familiar",
        component: InformacionFamiliar,
        layout: "/admin",
        color: "#EFEFEF",
        rol: ["DOCENTEGRADO,", "ADMINISTRATIVO,", "USUARIO,"]
    },
    {
        path: "/sustitutoInformacionFamiliar",
        name: "SUSTITUTO DE PERSONA CON DISCAPACIDAD",
        icon: "informacion_sustituto",
        component: SustitutoInformacionFamiliar,
        layout: "/admin",
        color: "#EFEFEF",
        rol: ["DOCENTEGRADO,", "ADMINISTRATIVO,"]
    },
    {
        path: "/informacion-academica",
        name: "INFORMACIÓN ACADÉMICA",
        icon: "informacion_academica",
        component: InformacionAcademica,
        layout: "/admin",
        color: "#EFEFEF",
        rol: ["DOCENTEGRADO,", "ADMINISTRATIVO,", "DOCENTEPOSTGRADO,", "USUARIO,"]
    },
    {
        path: "/informacion-academica-pos",
        name: "INFORMACIÓN ACADÉMICA",
        icon: "informacion_academica",
        component: InformacionAcademica_posext,
        layout: "/admin",
        color: "#EFEFEF",
        rol: ["DOCENTEPOSTGRADO_EXT,"]
    },
    {
        path: "/capacitaciones",
        name: "CAPACITACIONES",
        icon: "capacitaciones",
        component: Capacitaciones,
        layout: "/admin",
        color: "#EFEFEF",
        rol: ["DOCENTEGRADO,", "ADMINISTRATIVO,", "USUARIO,"]
    },
    {
        path: "/idiomas",
        name: "IDIOMAS",
        icon: "idiomas",
        component: Idiomas,
        layout: "/admin",
        color: "#EFEFEF",
        rol: ["DOCENTEGRADO,", "ADMINISTRATIVO,", "USUARIO,"]
    },
    {
        path: "/experiencia",
        name: "EXPERIENCIA",
        icon: "experiencia",
        component: Experiencia,
        layout: "/admin",
        color: "#EFEFEF",
        rol: ["DOCENTEGRADO,", "ADMINISTRATIVO,", "DOCENTEPOSTGRADO,", "USUARIO,"]
    },
    {
        path: "/experiencia-pos",
        name: "EXPERIENCIA",
        icon: "experiencia",
        component: Experiencia_posext,
        layout: "/admin",
        color: "#EFEFEF",
        rol: ["DOCENTEPOSTGRADO_EXT,"]
    },
    {
        path: "/experiencia-en-proyectos",
        name: "EXPERIENCIA EN PROYECTOS",
        icon: "proyectos",
        component: ExperienciaProyectos,
        layout: "/admin",
        color: "#EFEFEF",
        rol: ["DOCENTEGRADO,", "ADMINISTRATIVO,", "USUARIO,"]
    },
    {
        path: "/convenios",
        name: "CONVENIOS ADMINISTRADOS",
        icon: "convenios",
        component: Convenios,
        layout: "/admin",
        color: "#EFEFEF",
        rol: ["DOCENTEGRADO,", "ADMINISTRATIVO,"]
    },
    {
        path: "/publicaciones-realizadas",
        name: "PUBLICACIONES REALIZADAS",
        icon: "publicaciones",
        component: PublicacionesRealizadas,
        layout: "/admin",
        color: "#EFEFEF",
        rol: ["DOCENTEGRADO,", "ADMINISTRATIVO,", "USUARIO,"]
    },
    {
        path: "/otros-productos",
        name: "OTROS PRODUCTOS",
        icon: "publicaciones",
        component: OtrosProductos,
        layout: "/admin",
        color: "#EFEFEF",
        rol: ["DOCENTEGRADO,"]
    },
    {
        path: "/patentes",
        name: "PATENTES Y OTROS GENÉRICOS",
        icon: "patentes",
        component: Patentes,
        layout: "/admin",
        color: "#EFEFEF",
        rol: ["DOCENTEGRADO,", "ADMINISTRATIVO,"]
    },
    {
        path: "/direccion-de-tesis",
        name: "DIRECCIÓN DE TESIS",
        icon: "direccion_tesis",
        component: DireccionTesis,
        layout: "/admin",
        color: "#EFEFEF",
        rol: ["DOCENTEGRADO,"]
    },
    {
        path: "/evaluaciones",
        name: "EVALUACIONES",
        icon: "evaluaciones",
        component: Evaluaciones,
        layout: "/admin",
        color: "#EFEFEF",
        rol: ["DOCENTEGRADO,", "ADMINISTRATIVO,"]
    },
    {
        path: "/menciones-de-honor",
        name: "MENCIONES DE HONOR",
        icon: "menciones_honor",
        component: MencionesHonor,
        layout: "/admin",
        color: "#EFEFEF",
        rol: ["DOCENTEGRADO,", "ADMINISTRATIVO,", "USUARIO,"]
    },
    {
        path: "/CertificacionProfesional",
        name: "CERTIFICACIÓN O REGISTRO PROFESIONAL",
        icon: "certificacion",
        component: CertificacionProfesional,
        layout: "/admin",
        color: "#EFEFEF",
        rol: ["DOCENTEGRADO,"]
    },
    {
        path: "/miembro-de-organizacion",
        name: "MIEMBRO DE ORGANIZACIÓN",
        icon: "miembros_organizacion",
        component: MiembroOrganizacion,
        layout: "/admin",
        color: "#EFEFEF",
        rol: ["DOCENTEGRADO,"]
    },
    {
        path: "/actividades-academicas",
        name: "ACTIVIDADES ACADÉMICAS",
        icon: "actividades_academicas",
        component: ActividadesAcademicas,
        layout: "/admin",
        color: "#EFEFEF",
        rol: ["DOCENTEGRADO,"]
    },
    {
        path: "/desarrollo-profesional",
        name: "INTERESES INVESTIGACIÓN",
        icon: "experiencia",
        component: DesarrolloProfesional,
        layout: "/admin",
        color: "#EFEFEF",
        rol: ["DOCENTEGRADO,"]
    },
    {
        path: "/contratos-beca",
        name: "CONTRATOS DE BECA",
        icon: "contratos_becas",
        component: ContratosBecas,
        layout: "/admin",
        color: "#EFEFEF",
        rol: ["DOCENTEGRADO,", "ADMINISTRATIVO,"]
    }

];

export default dashRoutes;